```vue
<template>
  <section class="faq">
    <!-- =========================
         TERMS & CONDITIONS
    ========================== -->
    <div class="legal-section">
      <div v-if="termsContent" v-html="termsContent"></div>

      <div v-else-if="loadingLegal" class="legal-loading">Loading...</div>
    </div>

    <!-- =========================
         SEPARATOR
    ========================== -->
    <div v-if="termsContent && policyContent" class="legal-separator"></div>

    <!-- =========================
         PRIVACY POLICY
    ========================== -->
    <div class="legal-section">
      <div v-if="policyContent" v-html="policyContent"></div>

      <div v-else-if="loadingLegal" class="legal-loading">Loading...</div>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { apiMsg } from "@/provider";

export default {
  name: "Tnc",

  data() {
    return {
      titleHeader: "Syarat & Ketentuan",

      showToken: false,
      showBg: true,

      termsTitle: "SYARAT & KETENTUAN",
      policyTitle: "KEBIJAKAN PRIVASI",

      termsContent: "",
      policyContent: "",

      loadingLegal: false,
    };
  },

  computed: {
    ...mapState({
      coin: "coin",

      playerLang: (state) => (state.playerData && state.playerData.lang) || 0,
    }),
  },

  mounted() {
    this.loadLegalContent();
  },

  watch: {
    // Jika bahasa berubah,
    // tetap hanya melakukan 1 request
    playerLang() {
      this.loadLegalContent();
    },
  },

  methods: {
    /**
     * Build Terms & Conditions HTML
     */
    buildTermsHtml(terms) {
      if (!terms) {
        return "";
      }

      let html = "";

      // =========================
      // TITLE
      // =========================

      if (terms.title) {
        html += `
          <h3>
            ${terms.title}
          </h3>
        `;
      }

      // =========================
      // INTRODUCTION
      // =========================

      if (terms.introduction) {
        html += `
          <div class="dis">
            ${this.formatText(terms.introduction)}
          </div>
        `;
      }

      // =========================
      // SECTIONS
      // =========================

      if (Array.isArray(terms.sections) && terms.sections.length > 0) {
        html += `<ol class="terms-list">`;

        terms.sections.forEach((section) => {
          if (!section) {
            return;
          }

          html += `<li class="terms-section">`;

          // Section title
          if (section.title) {
            html += `
              <div class="legal-section-title">
                ${this.formatText(section.title)}
              </div>
            `;
          }

          // Section items
          if (Array.isArray(section.items) && section.items.length > 0) {
            html += `<ol class="terms-sub-list">`;

            section.items.forEach((item) => {
              html += `
                <li>
                  ${this.formatText(item)}
                </li>
              `;
            });

            html += `</ol>`;
          }

          // Section content jika ada
          if (section.content) {
            html += `
              <div class="legal-content">
                ${this.formatText(section.content)}
              </div>
            `;
          }

          html += `</li>`;
        });

        html += `</ol>`;
      }

      // =========================
      // AMENDMENT NOTICE
      // =========================

      if (terms.amendment_notice) {
        html += `
          <div class="dis amendment-notice">
            ${this.formatText(terms.amendment_notice)}
          </div>
        `;
      }

      return html;
    },

    /**
     * Build Privacy Policy HTML
     */
    buildPolicyHtml(policy) {
      if (!policy) {
        return "";
      }

      let html = "";

      // =========================
      // TITLE
      // =========================

      if (policy.title) {
        html += `
          <h3>
            ${policy.title}
          </h3>
        `;
      }

      // =========================
      // SECTIONS
      // =========================

      if (Array.isArray(policy.sections) && policy.sections.length > 0) {
        policy.sections.forEach((section) => {
          if (!section) {
            return;
          }

          // Section title
          if (section.title) {
            html += `
              <h4>
                ${this.formatText(section.title)}
              </h4>
            `;
          }

          // Section content
          if (section.content) {
            html += `
              <div class="legal-content">
                ${this.formatText(section.content)}
              </div>
            `;
          }

          // Section items
          if (Array.isArray(section.items) && section.items.length > 0) {
            html += `<ul class="policy-list">`;

            section.items.forEach((item) => {
              html += `
                <li>
                  ${this.formatText(item)}
                </li>
              `;
            });

            html += `</ul>`;
          }
        });
      }

      return html;
    },

    /**
     * Format text dari API
     *
     * JSON API menggunakan newline (\n).
     * Kita convert newline menjadi <br>.
     */
    formatText(text) {
      if (!text) {
        return "";
      }

      return String(text).replace(/\r\n/g, "\n").replace(/\n/g, "<br>");
    },

    /**
     * ========================================
     * LOAD LEGAL CONTENT
     * ========================================
     */
    async loadLegalContent() {
      if (this.loadingLegal) {
        return;
      }

      this.loadingLegal = true;

      try {
        let savedLanguage = this.$store.state.playerData?.lang || 0;

        if (savedLanguage == 1) {
          savedLanguage = "en";
        } else if (savedLanguage == 0) {
          savedLanguage = "kh";
        }

        /**
         * ====================================
         * REQUEST
         * ====================================
         */
        const payload = {
          content: "tnc",
          lang: savedLanguage,
        };

        const { data } = await apiMsg.post("legal/content", payload);

        // console.log("Legal API Response:", data);

        /**
         * ====================================
         * GET BODY
         * ====================================
         */
        const responseData = data && data.data ? data.data : data;

        const body =
          responseData && responseData.body ? responseData.body : null;

        if (!body) {
          console.warn("Legal API body is empty");

          this.termsContent = "";
          this.policyContent = "";

          return;
        }

        /**
         * ====================================
         * TERMS & CONDITIONS
         * ====================================
         */
        const terms = body.terms_and_conditions || null;

        /**
         * ====================================
         * PRIVACY POLICY
         * ====================================
         */
        const policy = body.privacy_policy || null;

        /**
         * Build HTML
         */
        this.termsContent = this.buildTermsHtml(terms);

        this.policyContent = this.buildPolicyHtml(policy);

        /**
         * Update title dari API
         */
        if (terms && terms.title) {
          this.termsTitle = terms.title;
        }

        if (policy && policy.title) {
          this.policyTitle = policy.title;
        }

        // console.log("Terms Content:", this.termsContent);

        // console.log("Policy Content:", this.policyContent);
      } catch (error) {
        console.error("Failed to load legal content:", error);

        this.termsContent = "";
        this.policyContent = "";
      } finally {
        this.loadingLegal = false;
      }
    },

    goTo(page) {
      this.$router.push({
        name: page,
      });
    },
  },
};
</script>

<style>
body {
  background-color: white;
}
</style>

<style scoped>
/* =========================
   MAIN CONTAINER
========================= */

.faq {
  text-transform: none;
  text-align: left;
  padding: 10px;

  color: #ffffff69;

  text-align: justify;

  position: relative;
}

/* =========================
   LEGAL SECTION
========================= */

.legal-section {
  width: 100%;
}

/* =========================
   TITLE
========================= */

.faq h3 {
  font-size: 1.35rem;

  color: #fff;

  border-bottom: 1px solid #8688f838;

  padding-bottom: 8px;

  margin-top: 10px;
  margin-bottom: 18px;

  white-space: pre-line;
}

.faq h4 {
  font-size: 1.2rem;

  color: #fff;

  margin-top: 22px;
  margin-bottom: 10px;

  white-space: pre-line;
}

/* =========================
   BOLD
========================= */

.faq b {
  color: #fff;

  font-weight: 400;
}

/* =========================
   TERMS LIST
========================= */

.terms-list {
  counter-reset: item;

  margin-block-start: 0.3em !important;

  padding-inline-start: 10px;
}

.terms-list > li {
  display: block;

  margin-bottom: 15px;
}

.terms-list > li:before {
  content: counters(item, ".") ". ";

  counter-increment: item;

  font-weight: bold;

  color: #fff !important;
}

/* =========================
   TERMS SUB LIST
========================= */

.terms-sub-list {
  counter-reset: item;

  margin-top: 8px;

  padding-inline-start: 10px;
}

.terms-sub-list > li {
  display: block;

  margin-bottom: 8px;
}

.terms-sub-list > li:before {
  content: counters(item, ".") ". ";

  counter-increment: item;

  font-weight: bold;

  color: #fff !important;
}

/* =========================
   POLICY LIST
========================= */

.policy-list {
  padding-left: 25px;

  margin-top: 10px;
}

.policy-list li {
  margin-bottom: 10px;
}

/* =========================
   CONTENT
========================= */

.legal-content {
  margin-bottom: 12px;

  line-height: 1.6;
}

/* =========================
   INTRODUCTION
========================= */

.dis {
  line-height: 1.6;

  margin-bottom: 15px;
}

/* =========================
   AMENDMENT
========================= */

.amendment-notice {
  margin-top: 20px;
}

/* =========================
   SEPARATOR
========================= */

.legal-separator {
  width: 100%;

  height: 1px;

  background: #8688f838;

  margin: 35px 0;
}

/* =========================
   LOADING
========================= */

.legal-loading {
  width: 100%;

  text-align: center;

  padding: 30px 10px;

  color: #ffffff69;
}
</style>
```
